import { Link } from "gatsby"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import React from "react"
import LinkedinCircle from "./svg/LinkedinCircle"
import Logo from "./svg/logo"
import TwitterCircle from "./svg/TwitterCircle"

export default function Footer() {
  return (
    <div className="bg-blue-light relative">
      <div className="smileCurve bg-white h-16 md:h-32 absolute top-0 right-0 left-0"></div>
      <div className="max-w-6xl mx-auto lg:pb-24 pt-20 pb-10 mt-4 md:mt-20 text-blue-dark">
            <div className="md:mb-12"></div>
            <div className="flex flex-col md:flex-row px-6 md:px-8 relative z-10 pt-12">
              <div className="mr-auto mb-4 md:mb-0">
                <Link to="/" aria-label="Bankjoy Logo">
                  <div className="mb-1">
                    <Logo width={110} />
                  </div>
                </Link>
                <div className="flex space-x-2">
                  <a
                    href="https://www.linkedin.com/company/bankjoy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <LinkedinCircle />
                  </a>
                  <a
                    href="https://twitter.com/bankjoy"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Twitter"
                  >
                    <TwitterCircle />
                  </a>
                </div>
              </div>
              <div className="flex">
                <div className="flex flex-col mr-10 mb-4 md:mb-0">
                  <div className="text-sm mb-2 font-medium">Pages</div>
                  <Link
                    to="/"
                    className="text-sm mb-1 hover:text-blue transition-colors"
                  >
                    Homepage
                  </Link>
                  <Link
                    to="/blog"
                    className="text-sm mb-1 hover:text-blue transition-colors"
                  >
                    Blog
                  </Link>
                  <Link
                    to="/people"
                    className="text-sm mb-1 hover:text-blue transition-colors"
                  >
                    People
                  </Link>
                  <Link
                    to="/jobs"
                    className="text-sm mb-1 hover:text-blue transition-colors"
                  >
                    Jobs
                  </Link>
                  <Link
                    to="/security"
                    className="text-sm mb-1 hover:text-blue transition-colors"
                  >
                    Security
                  </Link>
                </div>
                <div className="flex flex-col mr-3">
                  <div className="text-sm mb-2 font-medium">Actions</div>
                  <OutboundLink
                    href="https://webforms.pipedrive.com/f/1Aj12jymq2lWRkoDMIk5EWpvZZ4H0lnoDDVX6kMxk9vrga8Y72OJLtEEYuuChGw5Z"
                    className="text-sm mr-3 mb-1 hover:text-blue transition-colors"
                  >
                    Schedule Demo
                  </OutboundLink>
                  <OutboundLink
                    href="https://bankjoy.zendesk.com/hc/en-us/requests/new"
                    className="text-sm mr-3 mb-1 hover:text-blue transition-colors"
                  >
                    Support
                  </OutboundLink>
                  <OutboundLink
                    href="mailto:contact@bankjoy.com"
                    className="text-sm mr-3 mb-1 hover:text-blue transition-colors"
                  >
                    Contact Us
                  </OutboundLink>
                </div>
              </div>
        </div>
      </div>
    </div>

    // <div className="bg-blue-50 h-72 mt-32 ">
    //     <div className="relative bg-red h-72 w-screen z-20">
    //       <div className="circled bg-white h-56 w-screen top-0 absolute z-10"></div>
    //       <div className="md:mb-12"></div>
    //       <div className="flex flex-col md:flex-row px-8 relative z-10 pt-12">
    //         <div className="mr-auto mb-4 md:mb-0">

    //             <Link to="/" aria-label="Bankjoy Logo">
    //               <div className="mb-1">
    //                 <Logo width={110} />
    //               </div>
    //             </Link>
    //           <div className="flex space-x-2">
    //             <a href="https://www.linkedin.com/company/bankjoy" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><LinkedinCircle /></a>
    //             <a href="https://twitter.com/bankjoy" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><TwitterCircle /></a>
    //           </div>
    //         </div>

    //         <div className="flex">
    //           <div className="flex flex-col mr-10 mb-4 md:mb-0">
    //             <div className="text-sm md:mb-2">Pages</div>
    //             <Link to="/" className="text-sm font-medium hover:text-blue transition-colors">Homepage</Link>
    //             <Link to="/blog" className="text-sm font-medium hover:text-blue transition-colors">Blog</Link>
    //             <Link to="/people" className="text-sm font-medium hover:text-blue transition-colors">People</Link>
    //             <a href="https://angel.co/company/bankjoy/jobs/" target="#blank" className="text-sm font-medium hover:text-blue transition-colors">Jobs</a>
    //           </div>
    //           <div className="flex flex-col mr-3">
    //             <div className="text-sm md:mb-2">Actions</div>
    //           <a href="mailto:contact@bankjoy.com" className="text-sm mr-3 font-medium hover:text-blue transition-colors">Schedule Demo</a>
    //           <a href="mailto:contact@bankjoy.com" className="text-sm mr-3 font-medium hover:text-blue transition-colors">Contact Us</a>
    //           </div>
    //         </div>

    //       </div>
    //     </div>
    // </div>
  )
}
